module.exports = __webpack_public_path__ + "static/media/pic2.7050aa38.jpg";